<template>
  <v-container class="grey lighten-5" fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn block color="primary" class="my-2">
          <a style="display: block; flex-grow: 1" class="text-button text-decoration-none white--text" target="_blank" download href="Anexa 7.1 Grila.docx">
            <v-icon left>mdi-download</v-icon>
            Grila de evaluare a eligibilitatii administrative
            <v-icon right>mdi-download</v-icon>
          </a>
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredAplicants"
          :items-per-page="10"
          class="elevation-1"
          single-select
          show-select
          item-key="id"
          v-model="selectedAplicant"
          :single-expand="false"
          :expanded.sync="expanded"
          show-expand
          :loading="loading">
          <template v-slot:top>
            <v-toolbar color="white" class="mb-1" flat>
              <v-icon>mdi-cog</v-icon>
              <v-divider vertical class="mx-2"></v-divider>
              <v-text-field v-model="search" clearable flat hide-details label="Cautare"></v-text-field>
              <v-spacer></v-spacer>

              <v-select
                v-model="filterBy2"
                solo
                flat
                hide-details
                :items="itemsF2"
                label="Filtrare dupa evaluare"
              ></v-select>
              <v-spacer></v-spacer>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Filtrare dupa data inscriere"
                    prepend-icon="mdi-event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    flat
                    hide-details
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
          </template>
          <template v-slot:item.evaluat="{ item }">
            <v-icon small :color="item.evaluare && item.evaluare[user.id] ? 'primary' : 'error'">
              {{ item.evaluare && item.evaluare[user.id] ? 'mdi-check' : 'mdi-close'}}
            </v-icon>
          </template>
          <template v-slot:item.aprobat="{ item }">
            <v-icon small :color="item.evaluare && item.evaluare[user.id] && item.evaluare[user.id].aprobat ? 'primary' : 'error'">
              {{ item.evaluare && item.evaluare[user.id] && item.evaluare[user.id].aprobat ? 'mdi-check' : 'mdi-close'}}
            </v-icon>
          </template>
          <template v-slot:item.dataevaluare="{ item }">
            <template v-if="item.evaluare && item.evaluare[user.id]">
              {{ new Date(item.evaluare[user.id].data).toLocaleString("ro-RO") }}
            </template>
          </template>
          <template v-slot:item.grila="{ item }">
            <template v-if="item.evaluare && item.evaluare[user.id] && item.evaluare[user.id].grila && !['admin', 'el presidente'].includes(user.role)">
              <a :href="item.evaluare[user.id].grila" download target="_blank" class="text-decoration-none">
                <v-icon color="primary">mdi-download</v-icon>
              </a>
            </template>
            <template v-else-if="['admin', 'el presidente'].includes(user.role)">
              <template v-for="(ev, index) in item.evaluare">
                <a
                  v-if="user.role === 'admin' || (user.role === 'el presidente' && user.comisie === ev.comisie)"
                  :title="`${ev.evaluator} - ${ev.comisie}`"
                  :key="index"
                  :href="ev.grila"
                  download
                  target="_blank"
                  class="text-decoration-none">
                  <v-icon color="primary">mdi-download</v-icon>
                </a>
              </template>
            </template>
          </template>
          <template v-slot:item.scor="{ item }">
            <template v-if="item.evaluare && item.evaluare[user.id] && user.role === 'evaluator'">
              <v-progress-linear class="my-1" :value="userTotal(item.evaluare[user.id].score)" color="blue-grey lighten-4" height="16">
                <small>Total: {{ userTotal(item.evaluare[user.id].score) }}</small>
              </v-progress-linear>
            </template>
            <template v-if="item.evaluare && ['admin', 'el presidente'].includes(user.role)">
              <template v-for="(ev, index) in item.evaluare">
                <template v-if="user.role === 'admin' || user.comisie === ev.comisie">
                  <div :key="index" style="min-width: 100px" class="my-2">
                    <v-progress-linear
                      :value="totalScoreUser(ev.score)"
                      color="blue-grey lighten-4"
                      height="16"
                      :title="`${ev.evaluator} - ${ev.comisie}`">
                      <small>Total: {{ totalScoreUser(ev.score) }} pct</small>
                    </v-progress-linear>
                  </div>
                </template>
              </template>
            </template>
            <template v-else-if="!item.evaluare">Fara evaluare</template>
          </template>

          <template v-slot:item.medie="{ item }">
            <template v-if="item.evaluare">
              <template v-for="comisie in comisii(item.evaluare)">
                <div :key="comisie.label" style="min-width: 100px" class="my-2">
                  <v-progress-linear
                    :value="comisie.score"
                    color="blue-grey lighten-4"
                    height="16">
                    <small>{{ comisie.label }}: {{ comisie.medie.toFixed(2) }} pct</small>
                  </v-progress-linear>
                </div>
              </template>
            </template>
          </template>

          <template v-slot:item.admis="{ item }">
            <template v-if="item.evaluare && item.evaluare[user.id] && !['admin', 'el presidente'].includes(user.role)">
              <v-icon :color="item.evaluare[user.id].admis ? 'primary' : 'error'">
                {{ item.evaluare[user.id].admis ? 'mdi-check' : 'mdi-close' }}
              </v-icon>
            </template>
            <template v-else-if="['admin', 'el presidente'].includes(user.role)">
              <template v-for="(ev, index) in item.evaluare">
                <v-icon
                  v-if="user.role === 'admin' || (user.role === 'el presidente' && user.comisie === ev.comisie)"
                  :key="index"
                  :color="ev.admis ? 'primary' : 'error'"
                  :title="`${ev.evaluator} - ${ev.comisie}`">
                  {{ ev.admis ? 'mdi-check' : 'mdi-close' }}
                </v-icon>
              </template>
            </template>
          </template>
          <template v-slot:item.created="{ item }">
            {{ new Date(item.created).toLocaleString("ro-RO") }}
          </template>
          <template v-slot:item.contestatii="{ item }">
            <template v-if="item.contestatii">
              <div v-for="(obj, key) in item.contestatii" :key="key">
                {{ new Date(obj.data).toLocaleString("ro-RO") }}
                <v-btn icon small @click="openAppealDetails(obj)">
                  <v-icon small>
                    {{ obj.file ? "mdi-information" : "mdi-information-outline" }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <template v-else>
              -
            </template>
          </template>

          <template v-slot:item.draft="{ item }">
            <template v-if="item.form">
              <v-icon :color="item.form.draft ? 'error' : 'success'">
                {{ item.form.draft ? 'mdi-close' : 'mdi-check' }}
              </v-icon>
            </template>
            <template v-else>
              -
            </template>
          </template>
          <template v-slot:item.lastSave="{ item }">
            <template v-if="item.form">
              {{ new Date(item.form.lastSave).toLocaleString("ro-RO") }}
            </template>
            <template v-else>
              -
            </template>
          </template>

          <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
            <v-icon v-if="user.role !== 'evaluator'" @click="expandRow(expand, !isExpanded, item.id)">{{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"}}</v-icon>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <step-board
              v-if="['admin', 'el presidente'].includes(user.role)"
              :colspan="headers.length"
              :expandedData="expandedData"
              :personalData="personalData"
              :item="item"
              :formKeys="applicantSteps"
              @reload="reloadForm(item.id)" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- aplicant name and grila download -->
    <v-row class="mt-4" no-gutters v-if="selectedAplicant.length && aplicantForm">
      <v-col cols="12">
        <h2 class="text-h6 text-center">
          Evaluarea lui {{ selectedAplicant[0].nume }} {{ selectedAplicant[0].prenume }}
          <template v-if="selectedAplicant[0].evaluare && selectedAplicant[0].evaluare[user.id] && selectedAplicant[0].evaluare[user.id].grila">
            <a :href="selectedAplicant[0].evaluare[user.id].grila" download target="_blank" class="ml-4 text-decoration-none">
              grila
              <v-icon right color="primary" small>mdi-download</v-icon>
            </a>
          </template>
        </h2>
        <v-progress-linear height="20" color="blue-grey lighten-4" :value="totalScore" rounded>
          <strong>{{ totalScore }} pct</strong>
        </v-progress-linear>
      </v-col>
    </v-row>

    <!-- forms -->
    <v-row class="mt-4" no-gutters v-if="selectedAplicant.length && aplicantForm">
      <v-col cols="6" class="pr-2 pt-2 pb-2">
        <v-expansion-panels multiple v-model="formPanels">
          <v-expansion-panel v-if="aplicantDetails && aplicantDetails.judet">
            <v-expansion-panel-header>
              Date personale
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Nume
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ aplicantDetails.nume }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Prenume
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ aplicantDetails.prenume }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      CNP
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ aplicantDetails.cnp }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Judet
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ aplicantDetails.judet }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Carte de Identitate
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <a v-for="url in aplicantDetails.ciUrl" :href="url" download target="_blank" :key="url" class="text-decoration-none">
                        <v-icon>mdi-download</v-icon>
                      </a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Certificat
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <a
                        v-for="url in aplicantDetails.certUrl"
                        :href="url"
                        download
                        target="_blank"
                        :key="url"
                        class="text-decoration-none">
                        <v-icon>mdi-download</v-icon>
                      </a>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-for="item in applicantSteps" :key="item.key">
            <v-expansion-panel-header>{{ item.title }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <template v-if="item.key === 'draft'">
                <v-icon :color="aplicantForm[item.key] ? 'error' : 'primary'">
                  {{ aplicantForm[item.key] ? "mdi-close" : "mdi-check" }}
                </v-icon>
                Aplicantul <strong v-if="aplicantForm[item.key]">NU</strong> a finalizat formularul
              </template>
              <template v-else-if="item.key === 'lastSave'">
                {{ aplicantForm[item.key] ? new Date(aplicantForm[item.key]).toLocaleString("ro-RO") : "informatie indisponibila" }}
              </template>
              <template v-else-if="item.key === 'step1'">
                <template v-for="property in ['cerere', 'declaratie', 'cazierjudiciar', 'cazierfiscal', 'cv']">
                  <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                    <v-img
                      class="white--text align-end"
                      height="100px"
                      :src="'img/files_closed.jpg'"
                    >
                    </v-img>
                    <v-card-subtitle>
                      {{ aplicantForm[item.key][property].name }}
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="downloadFile(aplicantForm[item.key][property])">
                        <v-icon color="primary">
                          mdi-download
                        </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <span>
                        {{ (aplicantForm[item.key][property].size / 1000).toFixed(2) }} Kb
                      </span>
                      <v-spacer></v-spacer>
                      <v-icon small :color="aplicantForm[item.key][property].saved ? 'primary' : 'grey'">
                        {{ aplicantForm[item.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </template>
              </template>
              <template v-else-if="item.key === 'step2'">
                <template v-for="property in ['file']">
                  <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                    <v-img
                      class="white--text align-end"
                      height="100px"
                      :src="'img/files_closed.jpg'"
                    >
                    </v-img>
                    <v-card-subtitle>
                      {{ aplicantForm[item.key][property].name }}
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="downloadFile(aplicantForm[item.key][property])">
                        <v-icon color="primary">
                          mdi-download
                        </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <span>
                        {{ (aplicantForm[item.key][property].size / 1000).toFixed(2) }} Kb
                      </span>
                      <v-spacer></v-spacer>
                      <v-icon small :color="aplicantForm[item.key][property].saved ? 'primary' : 'grey'">
                        {{ aplicantForm[item.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </template>

                <template v-for="property in text.step2">
                  <p :key="property.key" class="text-caption">
                    <span class="font-weight-bold">{{ property.label }}: </span>
                    {{ aplicantForm[item.key][property.key] }}
                  </p>
                </template>
              </template>
              <template v-else-if="item.key === 'step3'">
                <template v-for="property in text.step3">
                  <p :key="property.key" class="text-caption">
                    <v-icon color="success" small v-if="aplicantForm[item.key].selected.includes(property.key)">
                      mdi-check-circle
                    </v-icon>
                    <v-icon color="grey" small v-else>
                      mdi-checkbox-blank-circle-outline
                    </v-icon>
                    <span class="font-weight-bold pl-2">{{ property.label }} </span>
                  </p>
                </template>
              </template>
              <template v-else-if="item.key === 'step4'">
                <template v-for="property in ['xls', 'pdf']">
                  <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                    <v-img
                      class="white--text align-end"
                      height="100px"
                      :src="'img/files_closed.jpg'"
                    >
                    </v-img>
                    <v-card-subtitle>
                      {{ aplicantForm[item.key][property].name }}
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="downloadFile(aplicantForm[item.key][property])">
                        <v-icon color="primary">
                          mdi-download
                        </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <span>
                        {{ (aplicantForm[item.key][property].size / 1000).toFixed(2) }} Kb
                      </span>
                      <v-spacer></v-spacer>
                      <v-icon small :color="aplicantForm[item.key][property].saved ? 'primary' : 'grey'">
                        {{ aplicantForm[item.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </template>

                <template v-for="property in text.step4">
                  <p :key="property.key" class="text-caption">
                    <span class="font-weight-bold">{{ property.label }}: </span>
                    {{ aplicantForm[item.key][property.key] }} RON
                  </p>
                </template>
              </template>
              <template v-else-if="item.key === 'step5'">
                <template v-for="property in ['file']">
                  <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                    <v-img
                      class="white--text align-end"
                      height="100px"
                      :src="'img/files_closed.jpg'"
                    >
                    </v-img>
                    <v-card-subtitle>
                      {{ aplicantForm[item.key][property].name }}
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="downloadFile(aplicantForm[item.key][property])">
                        <v-icon color="primary">
                          mdi-download
                        </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <span>
                        {{ (aplicantForm[item.key][property].size / 1000).toFixed(2) }} Kb
                      </span>
                      <v-spacer></v-spacer>
                      <v-icon small :color="aplicantForm[item.key][property].saved ? 'primary' : 'grey'">
                        {{ aplicantForm[item.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </template>

                <template v-for="property in text.step5">
                  <p :key="property.key" class="text-caption">
                    <span class="font-weight-bold">{{ property.label }}: </span>
                    {{ aplicantForm[item.key][property.key] }}
                  </p>
                </template>
              </template>
              <template v-else-if="item.key === 'step6'">
                <template v-for="property in ['file', 'anotherfile']">
                  <v-card width="200" :key="property" style="display: inline-block" class="ma-4">
                    <v-img
                      class="white--text align-end"
                      height="100px"
                      :src="'img/files_closed.jpg'"
                    >
                    </v-img>
                    <v-card-subtitle>
                      {{ aplicantForm[item.key][property].name }}
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="downloadFile(aplicantForm[item.key][property])">
                        <v-icon color="primary">
                          mdi-download
                        </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <span>
                        {{ (aplicantForm[item.key][property].size / 1000).toFixed(2) }} Kb
                      </span>
                      <v-spacer></v-spacer>
                      <v-icon small :color="aplicantForm[item.key][property].saved ? 'primary' : 'grey'">
                        {{ aplicantForm[item.key][property].saved ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </template>
              </template>

              <template v-if="!['draft', 'lastSave'].includes(item.key)">
                <v-divider class="mt-4"></v-divider>
                <v-textarea
                  class="mt-4"
                  filled
                  dense
                  outlined
                  @input="updateComment($event, 'form', null, item.key)"
                  :value="comments.form[item.key]"
                  label="Comentariu"
                  auto-grow
                  rows="1">
                </v-textarea>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col
        class="pl-2 pb-2"
        style="border-left: 2px solid #ccc"
        cols="6">
        <v-card flat>
          <v-card-text class="pa-0">

            <v-stepper vertical class="mt-2">
              <template v-for="(section, index) in evaluatorSteps">
                <v-subheader
                  :key="index + 'header'"
                  class="font-weight-bold">
                  {{ section.label }}
                </v-subheader>
                <div class="mx-9 mb-2" :key="index + 'progress'">
                  <v-progress-linear
                    :value="getSectionValue(index) * 100 / sectionTotals[index]"
                    rounded
                    height="20"
                    color="blue-grey lighten-4">
                    <strong>{{ getSectionValue(index) }} pct</strong>
                  </v-progress-linear>
                </div>
                <template v-for="step in evaluatorSteps[index].items">
                  <v-stepper-step
                    :key="index + step.step + 'head'"
                    :step="index[7] + '.' + step.step"
                    editable
                    edit-icon="mdi-check">
                    {{ step.step }} - {{ step.title }}
                    <small>{{ points[index][step.step] }} pct</small>
                  </v-stepper-step>
                  <v-stepper-content :key="index + step.step + 'body'" :step="index[7] + '.' + step.step" class="mr-2 pr-2">
                    <div class="pr-5 ml-2">
                      <div class="caption" v-html="step.description"></div>

                      <template v-if="step.type === 'group'">
                        <v-radio-group
                          v-model="points[index][step.step]"
                          :ref="`step-${index}.${step.step}`"
                        >
                          <v-radio
                            v-for="(value, index) in step.values"
                            :key="value"
                            :label="`${step.labels[index]} (${value} pct)`"
                            :value="value"
                          ></v-radio>
                        </v-radio-group>
                      </template>

                      <v-divider class="mt-4"></v-divider>
                      <v-textarea
                        class="mt-4"
                        filled
                        dense
                        outlined
                        @input="updateComment($event, 'points', index, `step${step.step}`)"
                        :value="comments.points[index][`step${step.step}`]"
                        label="Comentariu"
                        auto-grow
                        rows="1">
                      </v-textarea>
                    </div>
                  </v-stepper-content>
                </template>
              </template>
            </v-stepper>

            <form ref="grilaForm" style="display: none">
              <input type="file" ref="grilaInput" @change="grilaPicked" />
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-switch
              v-model="admis"
              :label="admis ? 'Admis' : 'Respins'"
              class="mr-4">
            </v-switch>
            <v-btn color="accent" @click="triggerGrilaPicker">
              Incarca grila
              <v-icon right>mdi-file-document</v-icon>
            </v-btn>
            <v-btn color="primary" @click="saveEvaluation">
              Salveaza evaluarea
              <v-icon left>mdi-content-save</v-icon>
              <template v-if="grila">
                +
                <v-icon right>mdi-file-document</v-icon>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- form not submitted -->
    <v-row v-if="selectedAplicant.length && !aplicantForm">
      <v-col cols="12">
        <v-alert type="warning" icon="mdi-alert">
          Aplicantul nu a completat formularul.
        </v-alert>
      </v-col>
    </v-row>

    <!-- no aplicant selected -->
    <v-row v-if="!selectedAplicant.length">
      <v-col cols="12">
        <v-alert type="info" icon="mdi-information">
          Pentru a putea incepe evaluarea selectati un aplicant din tabelul de mai sus.
        </v-alert>
      </v-col>
    </v-row>

    <v-dialog v-model="appealDetailsDialog" max-width="500" persistent>
      <v-card v-if="selectedAppeal">
        <v-card-title>
          <div>
            Contestatie
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeAppealDetails" color="error">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          {{ new Date(selectedAppeal.data).toLocaleString("ro-RO") }}
        </v-card-subtitle>
        <v-card-text>
          <div v-text="selectedAppeal.text"></div>
          <a :href="selectedAppeal.file" v-if="selectedAppeal.file" target="_blank">
            Descarca fisier
          </a>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeAppealDetails">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import StepBoard from "@/components/StepBoard.vue";

import _debounce from "lodash.debounce";

export default {
  name: "evaltuator-component",
  components: {
    "step-board": StepBoard
  },
  data() {
    return {
      expanded: [],
      expandedData: {},
      personalData: {},
      admis: false,
      formPanels: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      selectedAplicant: [],
      date: null,
      menu: false,
      filterBy1: "toate",
      filterBy2: "toate",
      search: null,
      applicantSteps: [],
      itemsF2: ["Evaluat", "Neevaluat", "Toate"],
      headers: [
        {
          text: "NrCrt",
          value: "nrcrt",
          align: "end",
          sortable: true,
          filterable: true
        },
        {
          text: "Nume aplicant",
          value: "nume",
          align: "start",
          sortable: true,
          filterable: true
        },
        {
          text: "Prenume aplicant",
          value: "prenume",
          align: "start",
          sortable: true,
          filterable: true
        },
        {
          text: "Evaluat",
          value: "evaluat",
          align: "start",
          sortable: true,
          filterable: false
        },
        {
          text: "Data evaluare",
          value: "dataevaluare",
          align: "start",
          sortable: true,
          filterable: false
        },
        {
          text: "Scor",
          value: "scor",
          align: "end",
          sortable: true,
          filterable: false
        },
        {
          text: "Medie",
          value: "medie",
          align: "start",
          sortable: true,
          filterable: false
        },
        {
          text: "Admis",
          value: "admis",
          align: "end",
          sortable: true,
          filterable: false
        },
        {
          text: "Grila",
          value: "grila",
          align: "center",
          sortable: false,
          filterable: false
        },
        {
          text: "Contestatii",
          value: "contestatii",
          align: "start",
          sortable: false,
          filterable: false
        },
        {
          text: "Data Inscriere",
          value: "created",
          align: "start",
          sortable: true,
          filterable: false
        },
        {
          text: "Depus",
          value: "draft",
          align: "center",
          sortable: true,
          filterable: false
        },
        {
          text: "Ultima salvare",
          value: "lastSave",
          align: "center",
          sortable: true,
          filterable: false
        },
        {
          text: "Evaluari",
          value: "data-table-expand"
        }
      ],

      sectionTotals: Object.freeze({
        section1: 25,
        section2: 10,
        section3: 8,
        section4: 20,
        section5: 12,
        section6: 8,
        section7: 10,
        section8: 7,
      }),

      evaluatorSteps: Object.freeze({
        section1: {
          label: "Descrierea afacerii și a strategiei de implementare a Planului de Afacere",
          items: [
            {
              step: 1,
              title: "Istoricul ideii de afacere",
              description: `
                Prezentare:
                <ul>
                <li>ideea de afacere socială;</li>
                <li>problema/ nevoia socială pe care o rezolvă;</li>
                <li>categorii de persoane cărora li se adresează întreprinderea socială respectivă şi nevoile sociale ale acestora;</li>
                <li>problema comunitară/de mediu pe care încearcă să o rezolve întreprinderea</li>
                </ul>
              `,
              values: [0, 2, 5],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informaţii incomplete",
                "sunt prezentate informaţii complete"
              ],
              type: "group"
            },
            {
              step: 2,
              title: "Descrierea întreprinderii sociale care se va înființa",
              description: `
                <p>Denumire, forma juridică, localitate, sediu</p>
                <p>Metodologia de organizare a intreprinderii de economie sociala este clar prezentata, cu accent pe modul in care se asigura participarea membrilor si a altor actori interesati la realizarea scopului social</p>
              `,
              values: [0, 2, 5],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informaţii incomplete",
                "sunt prezentate informaţii complete"
              ],
              type: "group"
            },
            {
              step: 3,
              title: "Misiunea și viziunea întreprinderii sociale",
              description: `
                <p>Misiunea si programele sociale sunt clar prezentate si definite in raport cu problemele si nevoile specifice ariei de implementare a proiectului; Misiunea si viziunea economica sunt clar prezentate si definite</p>
              `,
              values: [0, 2, 5],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informaţii incomplete",
                "informații complete și relevante sunt prezentate"
              ],
              type: "group"
            },
            {
              step: 4,
              title: "Obiectivele specifice ale întreprinderii sociale",
              description: `
                <p>Obiectivele sociale si economice</p>
              `,
              values: [0, 2, 4],
              labels: [
                "nu s-au formulat obiective relevante",
                "s-au formulat obiectivele, dar nu  în mod clar, fară a se putea cuantifica",
                "s-au formulat obiectivele în mod clar,cuantificabil, realizabile pentru tipul de afacere și dimensiunea afacerii sociale propuse"
              ],
              type: "group"
            },
            {
              step: 5,
              title: "Activitățile necesare implementării Planului de Afacere",
              description: `
                <ul>
                  <li>ista activităților și grafic Gantt;</li>
                  <li>escriere detaliata a activitatlor aducatoare de venit</li>
                  <li>ezultate si indicatori</li>
                </ul>
              `,
              values: [0, 1, 3, 6],
              labels: [
                "nu s-a completat",
                "activitățile propuse nu sunt corelate cu obiectivele și cu perioada stabilită  în Planul de Afacere;",
                "activitățile propuse sunt prezentate în mod clar, sintetic, cronologic, nu prezintă clar rezultate si indicatori; nu este corelare cu graficul Gantt",
                "activitățile propuse sunt prezentate în mod clar, sintetic, cronologic; prezintă rezultate si indicatori; s-a completat corect/corelat graficul Gantt"
              ],
              type: "group"
            }
          ]
        },
        section2: {
          label: "Analiza SWOT",
          items: [
            {
              step: 1,
              title: "",
              description: `
                Puncte tari. Puncte slabe, oportunități, amenințări
              `,
              values: [0, 2, 5],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete și nerelevante",
                "sunt prezentate informații complete și relevante (cel puțin 3 elemente pentru fiecare componentă)"
              ],
              type: "group"
            },
            {
              step: 2,
              title: "",
              description: `
                Valorificarea oportunităților și gestionarea amenințărilor
              `,
              values: [0, 2, 5],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete",
                "sunt propuse măsuri realiste de valorificare a oportunităților și gestionare a amenințărilor."
              ],
              type: "group"
            }
          ]
        },
        section3: {
          label: "Managementul firmei",
          items: [
            {
              step: 1,
              title: "Politica de resurse umane",
              description: `
                <ul>
                  <li>Care este numărul de persoane angajate în întreprinderea socială nou înfiinţată pentru funcționarea afacerii?</li>
                  <li>Care sunt competențele, expertiza și pozițiile necesare pentru operarea afacerii?</li>
                  <li>Organigrama estimativă</li>
                  <li>Politica de salarizare și instruire.</li>
                </ul>
              `,
              values: [0, 1, 3, 5],
              labels: [
                "nu sunt prezentate informații",
                "politica de resurse umane abordată confuz și parțial",
                "politica de resurse umane este prezentată clar, dar incompletă",
                "politica de resurse umane prezentată clar, concis, complet, corelată cu obiectivele și activitățile Planului de Afacere."
              ],
              type: "group"
            },
            {
              step: 2,
              title: "Fişe de post",
              description: `
              Fişe de post pentru persoanele prevăzute a fi angajate în cadrul întreprinderii sociale nou înfiinţate; tipul normei de lucru (întreaga/ parţială) şi numărul de ore per zi.
              `,
              values: [0, 1, 3],
              labels: [
                "nu sunt prezentate informații",
                "informații confuze, generale și nerelevante",
                "sunt prezentate informatii clare pentru fiecare fisa de post cu principalele caracteristici; prezentare complete si justificata"
              ],
              type: "group"
            }
          ]
        },
        section4: {
          label: "Descriere produse/servicii care fac obiectul afacerii sociale",
          items: [
            {
              step: 1,
              title: "Obiectul afacerii sociale",
              description: `
                Lista produselor/ serviciilor/ lucrărilor care fac obiectul principal al afacerii și caracteristicile lor
              `,
              values: [0, 1, 3, 5],
              labels: [
                "nu sunt prezentate informații",
                "informații confuze, generale și nerelevante",
                "descrierea clară pentru fiecare produs/serviciu cu principalele caracteristici",
                "evidențierea caracteristicilor produselor/serviciilor care le pot oferi un avantaj concurențial pe piață"
              ],
              type: "group"
            },
            {
              step: 2,
              title: "Fluxul activităților de producție/ prestări servicii/ comerț",
              description: `
                Descrierea fluxului activității/ activităților pentru fabricarea de produse, furnizarea de servicii sau comerț;
              `,
              values: [0, 1, 5],
              labels: [
                "nu sunt prezentate informații",
                "informații confuze, generale și nerelevante",
                "descrierea clară a fluxului pentru fabricarea de produse, furnizarea de servicii sau comerț"
              ],
              type: "group"
            },
            {
              step: 3,
              title: "",
              description: `
                Estimare spații necesare pentru organizarea activității (spațiu operațional, activități de birou etc)
              `,
              values: [0, 3],
              labels: [
                "nu sunt prezentate informații despre spații",
                "sunt prezentate informații complete și relevante despre spații"
              ],
              type: "group"
            },
            {
              step: 4,
              title: "Principalele echipamente/utilaje care vor fi achiziționate pentru demararea și operaționalizarea afacerii sociale",
              description: `
              `,
              values: [0, 1, 4],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete și nerelevante",
                "sunt prezentate informații complete și relevante"
              ],
              type: "group"
            },
            {
              step: 5,
              title: "Caracterul inovativ al produselor/serviciilor care constituie obiectul de activitate al afacerii sociale",
              description: `
              `,
              values: [0, 3],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații complete și relevante privind caracterul inovativ al produselor/serviciilor"
              ],
              type: "group"
            }
          ]
        },
        section5: {
          label: "Analiza pieței",
          items: [
            {
              step: 1,
              title: "Concurenți potențiali",
              description: `
                Lista produselor/ serviciilor/ lucrărilor care fac obiectul principal al afacerii și caracteristicile lor
              `,
              values: [0, 1, 2, 5],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete și nerelevante",
                "analiza concurenței nu se raportează la propriile produse/servicii care se vor lansa pentru a defini diferența între acestea și produsele pe piață ale concurenței",
                "analiza concurenței este completă, corectă, clară și evidențiază atât diferențierea dintre propriile produse și cele ale concurenței, cât și o analiză pertinentă și relevantă a valorificării punctelor tari și slabe ale concurenței în favoarea sa"
              ],
              type: "group"
            },
            {
              step: 2,
              title: "Descrierea publicului țintă",
              description: `
                Cine cumpără produsul sau serviciul?
              `,
              values: [0, 4],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații complete și relevante privind publicului țintă"
              ],
              type: "group"
            },
            {
              step: 3,
              title: "Oportunități de creștere a întreprinderii sociale",
              description: `
              `,
              values: [0, 3],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații complete și relevante privind creșterea întreprinderii sociale"
              ],
              type: "group"
            }
          ]
        },
        section6: {
          label: "Strategia de Marketing",
          items: [
            {
              step: 1,
              title: "Politica de Produs",
              description: `
                Modul de prezentare, ambalaje, etichetare, servicii post-vânzare oferite
              `,
              values: [0, 1, 2],
              labels: [
                "nu sunt prezentate informații",
                "politica produsului /serviciilor este prezentată incomplet ",
                "politica produsului este corectă și corespunde nevoilor și cerințelor clienților"
              ],
              type: "group"
            },
            {
              step: 2,
              title: "Politica de Preț",
              description: `
              `,
              values: [0, 1, 2],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete și nerelevante despre politica de prețuri, nu sunt prezentate prețuri estimate",
                "sunt prezentate informații clare despre politica de prețuri, iar prețurile estimate sunt fundamentate realist"
              ],
              type: "group"
            },
            {
              step: 3,
              title: "Politica de Distribuție/Plasare",
              description: `
                Strategia de distribuție (aprovizionare, stocare, depozitare și transmitere a produselor către utilizatorul final) este prezentată
              `,
              values: [0, 1, 2],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete și nerelevante despre Politica de Distribuție/Plasare ",
                "sunt prezentate informații clare despre politica de Distribuție/Plasare; modelele de distribuție adecvate caracteristicilor produselor/serviciilor"
              ],
              type: "group"
            },
            {
              step: 4,
              title: "Politica de Promovare",
              description: `
                Canalele de promovare, mesajul de promovare
              `,
              values: [0, 1, 2],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete și nerelevante",
                "promovarea produselor/serviciilor este realizabilă, canalele de promovare și mesajele adecvate pieței și caracteristicilor produselor/serviciilor"
              ],
              type: "group"
            }
          ]
        },
        section7: {
          label: "Proiecții financiare",
          items: [
            {
              step: 1,
              title: "Bugetul operațional. Venituri și cheltuieli din activitatea de exploatare",
              description: `
              `,
              values: [0, 2, 4],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete",
                "sunt prezentate informații clare și complete"
              ],
              type: "group"
            },
            {
              step: 2,
              title: "Bugetul Investiției",
              description: `
              `,
              values: [0, 2, 4],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete",
                "sunt prezentate informații clare și complete "
              ],
              type: "group"
            },
            {
              step: 3,
              title: "Plan de Finanțare a Afacerii",
              description: `
              `,
              values: [0, 1, 2],
              labels: [
                "nu sunt prezentate informații",
                "sunt prezentate informații incomplete",
                "sunt prezentate informații complete"
              ],
              type: "group"
            }
          ]
        },
        section8: {
          label: "Sustenabilitatea ",
          items: [
            {
              step: 1,
              title: "Sustenabilitatea economică",
              description: `
              `,
              values: [0, 2, 3],
              labels: [
                "nu s-a abordat subiectul",
                "s-a prezentat modul în care afacerea se va autosusține financiar 6 luni după încetare finanțării, dar nu s-au prezentat masuri pentru menținerea locurilor de muncă",
                "complet prezentata sustenabilitatea; alte măsuri pentru asigurare cashflow, realizare venituri și acoperire cheltuieli"
              ],
              type: "group"
            },
            {
              step: 2,
              title: "Sustenabilitatea financiara",
              description: `
              `,
              values: [0, 2, 4],
              labels: [
                "Contributia solicitantului este < de 2500 lei",
                "Contributia solicitantului este > 2500 si < de 5000 lei",
                "Contributia solicitantului este > 5000 de lei"
              ],
              type: "group"
            }
          ]
        }
      }),

      points: {
        section1: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        section2: { 1: 0, 2: 0 },
        section3: { 1: 0, 2: 0 },
        section4: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        section5: { 1: 0, 2: 0, 3: 0 },
        section6: { 1: 0, 2: 0, 3: 0, 4: 0 },
        section7: { 1: 0, 2: 0, 3: 0 },
        section8: { 1: 0, 2: 0 }
      },
      aplicantForm: null,
      aplicantDetails: null,

      appealDetailsDialog: false,
      selectedAppeal: null,

      grila: null,

      text: Object.freeze({
        step2: [
          { key: 'denumire', label: 'a) Denumirea planului de afaceri' },
          { key: 'sediu', label: 'b) Sediul social' },
          { key: 'activitate', label: 'c) Activitate principala (CAEN)' },
          { key: 'derulare', label: 'd) Perioada de derulare a activitatilor pentru care se primeste subventia (obligatiu 18 luni)' },
          { key: 'sustenabilitate', label: 'e) Perioada de sustenabilitate (minimum 6 luni)' }
        ],
        step3: [
          { key: 'dezvoltare', label: 'a) Promovarea dezvoltarii durabile' },
          { key: 'egalitate', label: 'b) Egalitatea de sanse' },
          { key: 'co2', label: 'c) Reducerea emisiei de dioxid de carbon' },
          { key: 'tic', label: 'd) Utilizarea TIC' },
          { key: 'inovare', label: 'e) Inovare sociala' },
          { key: 'cercetare', label: 'f) Promovarea cercetarii' }
        ],
        step4: [
          { key: 'subventie', label: 'Valoarea subventiei solicitate' },
          { key: 'contributie', label: 'Contributia proprie' }
        ],
        step5: [
          { key: 'text', label: 'Mentioneaza numarul de angajati, conform planului de afaceri' }
        ]
      }),

      comments: {
        form: {
          step1: null,
          step2: null,
          step3: null,
          step4: null,
          step5: null,
          step6: null
        },
        points: {
          section1: { step1: null, step2: null, step3: null, step4: null, step5: null },
          section2: { step1: null, step2: null },
          section3: { step1: null, step2: null },
          section4: { step1: null, step2: null, step3: null, step4: null, step5: null },
          section5: { step1: null, step2: null, step3: null },
          section6: { step1: null, step2: null, step3: null, step4: null },
          section7: { step1: null, step2: null, step3: null },
          section8: { step1: null, step2: null }
        }
      }
    };
  },

  watch: {
    selectedAplicant: {
      deep: true,
      async handler (value, old) {
        if (value !== old && value.length) {
          // reset points and comments and grila
          this.points = JSON.parse(JSON.stringify(points));
          this.comments = JSON.parse(JSON.stringify(comments));
          this.grila = null;
          this.aplicantForm = null;

          const form = await this.$store.dispatch("fetchAplicantForm", value[0].id);
          this.aplicantForm = form;
          const personal = await this.$store.dispatch("loadUserPersonal", value[0].id);
          this.aplicantDetails = personal;

          if (value[0].evaluare && value[0].evaluare[this.user.id]) {
            this.admis = value[0].evaluare[this.user.id].admis;
          }

          if (value[0].evaluare && value[0].evaluare[this.user.id] && value[0].evaluare[this.user.id].points) {
            this.points = value[0].evaluare[this.user.id].points;
          }
          if (value[0].evaluare && value[0].evaluare[this.user.id] && value[0].evaluare[this.user.id].comments) {
            if (value[0].evaluare[this.user.id].comments.form) {
              this.comments.form = Object.assign(this.comments.form, value[0].evaluare[this.user.id].comments.form)
            }
            if (value[0].evaluare[this.user.id].comments.points) {
              if (value[0].evaluare[this.user.id].comments.points.section1) {
                this.comments.points.section1 = Object.assign(this.comments.points.section1, value[0].evaluare[this.user.id].comments.points.section1)
              }
              if (value[0].evaluare[this.user.id].comments.points.section2) {
                this.comments.points.section2 = Object.assign(this.comments.points.section2, value[0].evaluare[this.user.id].comments.points.section2)
              }
              if (value[0].evaluare[this.user.id].comments.points.section3) {
                this.comments.points.section3 = Object.assign(this.comments.points.section3, value[0].evaluare[this.user.id].comments.points.section3)
              }
              if (value[0].evaluare[this.user.id].comments.points.section4) {
                this.comments.points.section4 = Object.assign(this.comments.points.section4, value[0].evaluare[this.user.id].comments.points.section4)
              }
              if (value[0].evaluare[this.user.id].comments.points.section5) {
                this.comments.points.section5 = Object.assign(this.comments.points.section5, value[0].evaluare[this.user.id].comments.points.section5)
              }
              if (value[0].evaluare[this.user.id].comments.points.section6) {
                this.comments.points.section6 = Object.assign(this.comments.points.section6, value[0].evaluare[this.user.id].comments.points.section6)
              }
              if (value[0].evaluare[this.user.id].comments.points.section7) {
                this.comments.points.section7 = Object.assign(this.comments.points.section7, value[0].evaluare[this.user.id].comments.points.section7)
              }
              if (value[0].evaluare[this.user.id].comments.points.section8) {
                this.comments.points.section8 = Object.assign(this.comments.points.section8, value[0].evaluare[this.user.id].comments.points.section8)
              }
            }
          }
        }
      }
    }
  },

  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    aplicants() {
      return this.$store.getters.allAplicants;
    },
    getSectionValue() {
      return section =>
        Object.keys(this.points[section]).reduce((sum, step) => {
          sum += this.points[section][step];

          return sum;
        }, 0);
    },
    totalScore() {
      return (
        this.getSectionValue("section1") +
        this.getSectionValue("section2") +
        this.getSectionValue("section3") +
        this.getSectionValue("section4") +
        this.getSectionValue("section5") +
        this.getSectionValue("section6") +
        this.getSectionValue("section7") +
        this.getSectionValue("section8")
      );
    },
    user() {
      return this.$store.getters.user;
    },
    filteredAplicants() {
      return this.aplicants.filter(item => {
        // filterBy1 -> aprobat, filterBy2 -> evaluat, date, search

        if (this.search) {
          if (
            (!item.nume || !item.nume.toLowerCase().includes(this.search.toLowerCase())) &&
            (!item.prenume || !item.prenume.toLowerCase().includes(this.search.toLowerCase()))
          )
            return false;
        }

        if (this.filterBy2 !== "toate") {
          if (this.filterBy2 === "Evaluat") {
            if (!item.evaluare) return false;
            else if (!item.evaluare[this.user.id]) return false;
          }
          if (this.filterBy2 === "Neevaluat") {
            if (item.evaluare && item.evaluare[this.user.id]) return false;
          }
        }

        if (this.date) {
          const inscriere = new Date(item.created).toISOString().split("T")[0];
          if (this.date !== inscriere) return false;
        }

        return true;
      });
    }
  },

  methods: {
    comisii(evaluare) {
      const comisii = {};

      Object.keys(evaluare).forEach(key => {
        if (this.user.role === 'evaluator') return;

        if (comisii[evaluare[key].comisie]) {
          if (this.user.role === 'admin' || (this.user.role === 'el presidente' && evaluare[key].comisie === this.user.comisie)) {
            comisii[evaluare[key].comisie].score += this.totalScoreUser(evaluare[key].score);
            comisii[evaluare[key].comisie].nrmembri++;
            // imparte la nr membri
          }
        } else {
          if (this.user.role === 'admin' || (this.user.role === 'el presidente' && evaluare[key].comisie === this.user.comisie)) {
            comisii[evaluare[key].comisie] = { label: evaluare[key].comisie, score: 0 };
            comisii[evaluare[key].comisie].score = this.totalScoreUser(evaluare[key].score);
            comisii[evaluare[key].comisie].nrmembri = 1;
          }
        }
      });

      Object.keys(comisii).forEach(comisie => {
        comisii[comisie].medie = comisii[comisie].score / comisii[comisie].nrmembri;
      });

      return comisii;
    },

    totalScoreUser(score) {
      return Object.keys(score).reduce((acc, key) => {
        acc += score[key];
        return acc;
      }, 0);
    },

    async expandRow(fn, arg, id) {
      fn(arg);
      if (arg) {
        const data = await this.$store.dispatch("loadUserForm", id);
        const personal = await this.$store.dispatch("loadUserPersonal", id);
        this.$set(this.expandedData, id, Object.freeze(data));
        this.$set(this.personalData, id, Object.freeze(personal));
      } else {
        delete this.expandedData[id];
        delete this.personalData[id];
      }
    },

    adjustStep(step, dir) {
      if (dir === -1) {
        this.points.section1[step.step] +=
          this.points.section1[step.step] > step.min ? dir : 0;
      } else {
        this.points.section1[step.step] +=
          this.points.section1[step.step] < step.max ? dir : 0;
      }
    },
    downloadFile(file) {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      link.target = "_blank";
      link.click();
      link.remove();
    },
    saveEvaluation () {
      const section1Score = this.getSectionValue("section1");
      const section2Score = this.getSectionValue("section2");
      const section3Score = this.getSectionValue("section3");
      const section4Score = this.getSectionValue("section4");
      const section5Score = this.getSectionValue("section5");
      const section6Score = this.getSectionValue("section6");
      const section7Score = this.getSectionValue("section7");
      const section8Score = this.getSectionValue("section8");
      this.$store.dispatch("saveEvaluation", {
        comisie: this.user.comisie,
        admis: this.admis,
        points: this.points,
        score: {
          section1: section1Score,
          section2: section2Score,
          section3: section3Score,
          section4: section4Score,
          section5: section5Score,
          section6: section6Score,
          section7: section7Score,
          section8: section8Score
        },

        grilaFile: this.grila,
        comments: this.comments,
        id: this.selectedAplicant[0].id
      });
      this.grila = null;
    },

    openAppealDetails(item) {
      this.selectedAppeal = item;
      this.appealDetailsDialog = true;
    },
    closeAppealDetails() {
      this.selectedAppeal = null;
      this.appealDetailsDialog = false;
    },

    triggerGrilaPicker() {
      this.$refs.grilaInput.click();
    },
    grilaPicked($event) {
      this.grila = $event.target.files[0];
      this.$refs.grilaForm.reset();
    },

    userTotal(score) {
      return score ? Object.keys(score).reduce((acc, key) => {
        acc += score[key];
        return acc;
      }, 0) : 0
    },
    updateComment: _debounce(function($event, where, section, key) {
      if (section) {
        this.comments[where][section][key] = $event;
      } else {
        this.comments[where][key] = $event;
      }
    }, 500),

    async reloadForm(id) {
      const data = await this.$store.dispatch("loadUserForm", id);
      this.$set(this.expandedData, id, Object.freeze(data));

      const personal = await this.$store.dispatch("loadUserPersonal", id);
      this.$set(this.personalData, id, Object.freeze(personal));
    }
  },

  mounted() {
    this.applicantSteps = formKeys;
    this.$store.dispatch("fetchAllAplicants");
  }
};

/* eslint-disable no-unused-vars */
const formKeys = Object.freeze([
  { key: "draft", title: "Temporar" },
  { key: "lastSave", title: "Ultima salvare" },
  { key: "step1", title: "Pasul 1 - Dosarul candidatului" },
  { key: "step2", title: "Pasul 2 - Descriere succinta plan de afaceri" },
  { key: "step3", title: "Pasul 3 - Temele orizontale sau secundare la care contribuie intreprinderea, conform planului de afaceri" },
  { key: "step4", title: "Pasul 4 - Asistenta financiara solicitata" },
  { key: "step5", title: "Pasul 5 - Numarul de angajati si fisele de post" },
  { key: "step6", title: "Pasul 6 - Planul de afaceri" }
]);

const points = {
  section1: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
  section2: { 1: 0, 2: 0 },
  section3: { 1: 0, 2: 0 },
  section4: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
  section5: { 1: 0, 2: 0, 3: 0 },
  section6: { 1: 0, 2: 0, 3: 0, 4: 0 },
  section7: { 1: 0, 2: 0, 3: 0 },
  section8: { 1: 0, 2: 0 }
};
const comments = {
  form: {
    step1: null,
    step2: null,
    step3: null,
    step4: null,
    step5: null,
    step6: null
  },
  points: {
    section1: { step1: null, step2: null, step3: null, step4: null, step5: null },
    section2: { step1: null, step2: null },
    section3: { step1: null, step2: null },
    section4: { step1: null, step2: null, step3: null, step4: null, step5: null },
    section5: { step1: null, step2: null, step3: null },
    section6: { step1: null, step2: null, step3: null, step4: null },
    section7: { step1: null, step2: null, step3: null },
    section8: { step1: null, step2: null }
  }
};
</script>
